<template>
    <ConfigCard
        badges=""
        :href="href"
        class="w-full"
        data-spec-class="special-deals-card"
        :data-spec-id="`special-deals-card--${server.id}`"
    >
        <div class="text-white">{{ server.name }}</div>
        <div
            v-if="server.cpu"
            class="text-xs text-blue-600"
        >
            {{ server.cpu }}
        </div>

        <div class="text-white">
            <div>{{ server.components.ram.name }} RAM</div>
            <div
                v-for="storage in server.components.storages"
                :key="storage.id"
            >
                <template v-if="storage.quantity > 1"> {{ storage.quantity }}x </template>
                {{ storage.name }}
            </div>
            <div>
                {{ server.uplink.name }}
            </div>
        </div>

        <input
            type="hidden"
            name="server"
            :value="server.id"
        />
        <template #aside>
            <slot name="aside"> </slot>
        </template>
    </ConfigCard>
</template>

<script setup>
import { defineProps } from 'vue';
import ConfigCard from './Configurator/ConfigCard.vue';

defineProps({
    server: {
        type: Object,
        required: true,
    },
    href: {
        type: String,
        default: undefined,
    },
});
</script>
